
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class DefaultComponentItem extends Vue {
  @Prop() dataSource:any
}
